// extracted by mini-css-extract-plugin
export default {"cor":"styles_cor__DIOFe","description":"styles_description__XMNR9"};